export default __webpack_public_path__ + "images/sellpage-test2-hero.jpg";